export const maxCompanyReportId = 50000;

export const companyReportAdminTranslation = {

  // section title
  manage_company_reports_title: 8857,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_company_reports: 8858,

  // messages
  no_access_to_company_report_admin: 8859,
  company_report_deleted: 8860,

  // list item
  disabled: 5251,
  open_company_report: 8861,
  edit_company_report: 8884,
  delete_company_report_title: 8862,
  delete_company_report_button: 9362,
  run_company_report: 8968,

  // confirmation
  delete_confirmation: 8863,
  cancel: 3273,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  company_report_created: 8879,
  company_report_updated: 8880,
  company_report_validation_error: 8206,
  saving_company_report: 8877,
  deleting_company_report: 8878,
  fields_are_filled_out_incorrectly: 8206,

  // form header
  new_company_report: 8875,
  save: 8946,
  add_new: 6943,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  predef_date: 8886,
  visibility: 8394,
  saved_reports: 7991,
  email_settings: 8864,
  descriptions_and_translations: 8391,
  excel_mappings: 8882,

  // dynamic periods
  dynamic_periods_use_label: 9009,
  dynamic_periods_use_info: 9062,
  dynamic_periods_default: 9010,
  dynamic_periods: 9043,
  dynamic_periods_info_text: 9044,

  // template
  template_title: 8885,
  template_name: 8887,
  template_default_name: 8888,
  template_upload: 8889,
  template_download: 8890,
  template_disclaimer: 8938,
  template_warning: 9055,

  submit: 8940,
  choose_file: 8939,
  upload_template: 8889,
  download_template: 8890,

  file_size_error: 8944,
  file_not_found: 8542,
  problem_uploading_file: 8538,
  upload_success: 8537,
  no_download_permission: 9011,
  no_upload_permission: 9012,
  reload_file: 8650,

  // language
  translations_header: 8364,
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,

  // fields
  sequence: 6825,
  access_mode: 8735,
  visible_for_user_groups: 8395,
  visible_for_case_types: 8396,
  visible_for_users_and_roles: 8736,
  cell: 8802,
  range: 8935,
  cell_placeholder: 9057,
  range_info_text: 9056,

  // manage options
  manage_options: 8521,

  // validation
  must_be_filled_out: 5949,
  must_be_within_range: 7939,
  at_least_one_must_be_filled_out: 9053,
  no_text: 8948,

  // email settings
  email_settings_report_checkbox: 3464,
  email_settings_subject_title: 8865,
  email_settings_body_title: 8866,
  email_settings_text_id: 8893,
  email_settings_text_set: 8892,
  email_text_description: 8891,
  email_manage_text: 8894,

  // excel mappings
  excel_mappings_info_text: 8870,
  excel_mappings_group_period: 8867,
  excel_mappings_group_favourite_condition: 8930,
  excel_mappings_group_favourite_condition_value: 8931,
  excel_mappings_group_generate_time: 8932,
  excel_mappings_group_search_parameters: 8933,
  excel_mappings_group_url: 8934,
  excel_mappings_no_data: 8947,

  // form saved reports
  show_details: 7640,
  hide_details: 7641,

  // saved report
  add_report: 8746,
  add_reports: 8835,
  add_report_by_id: 8845,
  add_new_report: 8945,
  saved_report_failed: 8756,
  show_disabled_elements: 8785,

  // saved report menu
  edit_connection: 8747,
  edit_report: 8329,
  no_rights_to_edit_report: 9844,
  move_up: 7743,
  move_down: 7538,

  // saved report modal
  add_saved_reports_title: 8844,
  saved_report_id: 8750,
  report_result: 9050,
  report_id: 9051,
  report_name: 9052,

  saved_id_validation: 9024,

  // filters
  filters: 7556,
  filters_info: 8881,
  add_filters: 8846,

  required: 9054,

  no_default_value: 8847,
  use_default_value: 8848,

  filters_my_unit: 7714,
  filters_my_location: 7715,
  filters_person: 7767,
  filters_not_supported: 8834,

  filters_date_range_date_fixed_period: 3706,
  filters_date_range_date_interval: 3707,
  filters_date_range_from: 7567,
  filters_date_range_to: 7600,

  // texts
  texts_title: 8972,
  add_text: 8970,
  texts_no_data: 8971,

  // metadata
  metadata_title: 8996,
  add_metadata: 8995,
  metadata_no_data: 8994,
  metadata_type: 8999,

  remove: 7742,
  remove_all: 8435,
  done: 7338
};

export type CompanyReportAdminTranslation = {
  readonly [T in keyof typeof companyReportAdminTranslation]: string
};

export const cellValidationText = 'Text must be unique. Change one of the highlighted fields and try again.';
